export const storyLA = {
    places: [
        {
            id: 1,
            name: "microsoft",
            coordinates: [-118.26676622723717, 34.04432350765479],
            popupHtml: '<span class="popup-title">Microsoft Theater</span>' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/microsoft-theater.jpg" alt="Microsoft Theater">' +
                '<span>Opened in 2007. A music and theater venue. The theater auditorium seats 7,100 and holds one of the largest indoor stages in the United States.</span>'
        },
        {
            id: 2,
            name: "bookstore",
            coordinates: [-118.24959951401462, 34.04769609653637],
            popupHtml: '<span class="popup-title">The Last Bookstore</span>' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/last-bookstore-internal.jpg" alt="The Last Bookstore">' +
                '<span>The store was founded in 2005. It is located in a former bank with books on two levels, including the former vault.</span>'

        },
        {
            id: 3,
            name: "disney",
            coordinates: [-118.24988946244828, 34.055455864645864],
            popupHtml: '<span class="popup-title">Walt Disney Concert Hall</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/walt-disney-hall.jpg" alt="Walt Disney Concert Hall">' +
                '<span>Opened in 2003. This performance venue is a gift to the people of Los Angeles and a tribute to Walt Disney\'s devotion to the arts and to the city</span>'
        },
        {
            id: 4,
            name: "broad",
            coordinates: [-118.25063315715954, 34.05440489632599],
            popupHtml: '<span class="popup-title">The Broad Museum</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/broad-museum.jpg" alt="The Broad Museum">' +
                '<span>Opened in 2015. A contemporary art museum on Grand Avenue. ' +
                'The Broad houses a nearly 2,000-piece collection of contemporary art, featuring 200 artists. ' +
                'The building will also serve as headquarters for the Broad Art Foundation\'s lending library of contemporary works.</span>'
        },
        {
            id: 5,
            name: "usbank",
            coordinates: [-118.25440582456434, 34.05106600482056],
            popupHtml: '<span class="popup-title">U.S. Bank Tower</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/us-bank.jpg" alt="U.S. Bank Tower">' +
                '<span>The building is opened in 1989, but previously it was the Library Tower and First Interstate Bank World Center. ' +
                'This is the third-tallest building in California, the second-tallest building in Los Angeles, the eighteenth-tallest in the United States. ' +
                'The structure was designed to resist an earthquake of 8.3 on the Richter scale. </span>'
        },
        {
            id: 6,
            name: "station",
            coordinates: [-118.23615334059522, 34.055807390791905],
            popupHtml: '<span class="popup-title">Los Angeles Union Station (LAUS)</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/union-station.jpg" alt="Union Station">' +
                '<span>The main railway station in Los Angeles, and the largest and busiest railroad passenger terminal in the Western United States. It opened in May 1939, ' +
                'replacing La Grande Station and Central Station. ' +
                '</span>'
        },
        {
            id: 7,
            name: "bradbury",
            coordinates: [-118.24791556567747, 34.05057280587245],
            popupHtml: '<span class="popup-title">Bradbury Building</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/bradbury-building-internal.jpg" alt="Bradbury Building">' +
                '<span>Built in 1893. The building was commissioned by Los Angeles gold-mining millionaire Lewis L. Bradbury. ' +
                'The building was added to the National Register of Historic Places in 1971, and was designated a National Historic Landmark in 1977.</span>'
        },
        {
            id: 8,
            name: "cityhall",
            coordinates: [-118.24280858753181, 34.05370170891533],
            popupHtml: '<span class="popup-title">Los Angeles City Hall</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/city-hall.jpg" alt="Los Angeles City Hall">' +
                '<span>Completed in 1928. It has 32 floors and, at 454 feet (138 m) high, is the tallest base-isolated structure in the world, ' +
                'having undergone a seismic retrofit from 1998 to 2001 so that the building will sustain minimal damage and remain functional after ' +
                'a magnitude 8.2 earthquake. </span>'
        },
        {
            id: 9,
            name: "cathedral",
            coordinates: [-118.24496523832453, 34.05766817222412],
            popupHtml: '<span class="popup-title">Cathedral of Our Lady of the Angels</span> ' +
                '<img class="popup-image" src="https://raw.githubusercontent.com/KonstantinBiryukov/KonstantinBiryukov.github.io/master/storytellingmaps-media/popup-images-LAstory/lady-angeles.jpg" alt="Cathedral of Our Lady of the Angels">' +
                '<span>Cathedral of the Roman Catholic Church. Opened in 2002. Using elements of postmodern architecture, the church and the Cathedral Center feature a series of acute and obtuse angles while avoiding right angles. </span>'
        },

    ]

}